import React, { Component } from "react";
import { reduxForm, Field, change } from "redux-form";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { toastr } from "react-redux-toastr";
import firebase from "../../../../app/config/firebase";
import asyncValidate from "../asyncValidate";
import validate from "../Validate";
import TextInput from "../../../../app/common/form/TextInput";
import AsyncTextInput from "../../../../app/common/form/TextInput";
import SelectInput from "../../../../app/common/form/SelectInput";
import { HAWKERS_PDF_ACCEPT } from "../../validateMerchantPdf";

const componentConfig = {
  iconFiletypes: [".jpg", ".png", ".gif"],
  showFiletypeIcon: true,
  postUrl: "/uploadHandler",
};

class MerchantDetails extends Component {
  state = {
    files: [],
    fileName: "",
    omang: [],
    omangFileName: "",
    affidavit: [],
    affidavitFileName: "",
    hawkersLicense: [],
    hawkersLicenseFileName: "",
    showAddPlaceForm: false,
    selectedDistrict: "",
    newPlaceName: "",
    isAddingPlace: false,
    addPlaceError: "",
    newlyAddedPlaces: [], // Track newly added places for immediate display
  };

  toggleAddPlaceForm = () => {
    this.setState((prev) => ({
      showAddPlaceForm: !prev.showAddPlaceForm,
      selectedDistrict: "",
      newPlaceName: "",
      addPlaceError: "",
    }));
  };

  handleAddPlace = async () => {
    const { selectedDistrict, newPlaceName } = this.state;
    const { merchantCities, dispatch } = this.props;

    // Validation
    if (!selectedDistrict) {
      this.setState({ addPlaceError: "Please select a district" });
      return;
    }

    if (!newPlaceName.trim()) {
      this.setState({ addPlaceError: "Please enter a place name" });
      return;
    }

    // Check if place already exists
    const placeExists = merchantCities.some((district) =>
      Object.values(district.places || {}).some(
        (place) => place.toLowerCase() === newPlaceName.trim().toLowerCase()
      )
    );

    if (placeExists) {
      this.setState({ addPlaceError: "This place already exists" });
      return;
    }

    this.setState({ isAddingPlace: true, addPlaceError: "" });

    try {
      const firestore = firebase.firestore();
      const districtRef = firestore.collection("botswana_districts").doc(selectedDistrict);
      const districtDoc = await districtRef.get();

      if (!districtDoc.exists) {
        this.setState({ addPlaceError: "District not found", isAddingPlace: false });
        return;
      }

      const districtData = districtDoc.data();
      const currentPlaces = districtData.places || {};

      // Use the place name as the key (matching existing data structure)
      const placeName = newPlaceName.trim();

      // Update the places object with the new place (key = value = place name)
      const updatedPlaces = {
        ...currentPlaces,
        [placeName]: placeName,
      };

      await districtRef.update({ places: updatedPlaces });

      // Auto-select the newly added place in the form
      dispatch(change("merchantForm", "merchantCity", newPlaceName.trim()));

      // Trigger the onmerchantCity callback if provided
      if (this.props.onmerchantCity) {
        this.props.onmerchantCity({ value: newPlaceName.trim(), label: newPlaceName.trim() });
      }

      toastr.success("Success", `"${newPlaceName.trim()}" has been added to ${districtData.district}`);

      // Add to local state for immediate display in dropdown
      this.setState((prevState) => ({
        showAddPlaceForm: false,
        selectedDistrict: "",
        newPlaceName: "",
        isAddingPlace: false,
        addPlaceError: "",
        newlyAddedPlaces: [...prevState.newlyAddedPlaces, placeName],
      }));
    } catch (error) {
      console.error("Error adding place:", error);
      this.setState({
        addPlaceError: "Failed to add place. Please try again.",
        isAddingPlace: false,
      });
      toastr.error("Error", "Failed to add place");
    }
  };

  render() {
    const { handleSubmit } = this.props;

    let sellers = {};

    sellers =
      this.props.sellerId &&
      this.props.sellerId.map((seller) => {
        return {
          label: seller.sellerId,
          value: seller.sellerId,
        };
      });

    let merchantTypes = {};

    merchantTypes =
      this.props.merchantTypes &&
      this.props.merchantTypes.map((merchantType) => {
        return {
          label: merchantType.type,
          value: merchantType.type,
        };
      });
    
    let merchantCities = [];

    // Get cities from Firestore data
    if (this.props.merchantCities) {
      merchantCities = this.props.merchantCities.flatMap((district) =>
        Object.values(district.places || {}).map((city) => ({
          label: city,
          value: city,
        }))
      );
    }

    // Add newly added places that might not be in Firestore cache yet
    const { newlyAddedPlaces } = this.state;
    if (newlyAddedPlaces && newlyAddedPlaces.length > 0) {
      const existingValues = new Set(merchantCities.map((c) => c.value.toLowerCase()));
      newlyAddedPlaces.forEach((place) => {
        if (!existingValues.has(place.toLowerCase())) {
          merchantCities.push({ label: place, value: place });
        }
      });
    }

    return (
      <form onSubmit={handleSubmit}>
        <p>
          <strong>Merchant Details</strong>
        </p>
        <div>
          <div className={"row clearfix"}>
            <div className={"col-sm-6"}>
              <Field
                name="merchantName"
                component={AsyncTextInput}
                type="text"
                className={"form-control"}
                placeholder={
                  this.props.merchantName == undefined || null
                    ? "Merchant Name"
                    : this.props.merchantName
                }
                onChange={this.props.onMerchantName}
                required="required"
              />
            </div>

            <div className={"col-sm-6"}>
              <Field
                name="merchantType"
                options={merchantTypes}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                    primary: "neutral0",
                  },
                })}
                component={SelectInput}
                placeholder={
                  this.props.merchantType == undefined || null
                    ? "Merchant Type"
                    : this.props.merchantType
                }
                // onChange={this.props.onmerchantType}
                className={"form-control"}
                required="true"
              />
            </div>
          </div>
          <div className={"row clearfix"}>
            <div className={"col-sm-6"}>
              <Field
                name="merchantId"
                component={AsyncTextInput}
                type="text"
                className={"form-control"}
                placeholder={
                  this.props.merchantId == undefined || null
                    ? "ID Number"
                    : this.props.merchantId
                }
                onChange={this.props.onMerchantId}
              />
              {this.props.invalidIdError ? (
                <p style={{ color: "red" }}>ID number is not valid</p>
              ) : null}
            </div>
            <div className={"col-sm-6"}>
              <Field
                name="merchantPass"
                component={AsyncTextInput}
                type="text"
                className={"form-control"}
                placeholder={
                  this.props.merchantPass == undefined || null
                    ? "Passport Number"
                    : this.props.merchantPass
                }
                onChange={this.props.onmerchantPass}
              />
            </div>
            {this.props.idPassError ? (
              <p style={{ color: "red" }}>
                Either ID Number or Passport Number must be provided
              </p>
            ) : null}
          </div>
          <br />

          <div className={"row clearfix"}>
            <div className={"col-lg-6"}>
              <p>
                <strong> Signed Merchant Registration Form</strong>
              </p>
              <div className={"card card-default"}>
                {this.props.files && this.props.files[0] ? (
                  <div className={"card-body no-scroll no-padding dropzone "}>
                    <p
                      style={{
                        lineHeight: "50px",
                        margin: 0,
                        textAlign: "center",
                      }}
                    >
                      {this.props.files[0].name}
                    </p>
                  </div>
                ) : (
                  <div className={"card-body no-scroll no-padding dropzone "}>
                    <Dropzone
                      config={componentConfig}
                      onDrop={this.props.onDrop}
                      multiple={false}
                    >
                      {({ getRootProps, getInputProps, isDragActive }) => {
                        return (
                          <div
                            {...getRootProps()}
                            style={{ textAlign: "center" }}
                          >
                            <input {...getInputProps()} />
                            {isDragActive ? (
                              <p style={{ lineHeight: "50px", margin: 0 }}>
                                Drop files here...
                              </p>
                            ) : (
                              <p style={{ lineHeight: "50px", margin: 0 }}>
                                Click to select files to upload.
                              </p>
                            )}
                          </div>
                        );
                      }}
                    </Dropzone>
                  </div>
                )}
              </div>
            </div>
            <div className={"col-lg-6"}>
              <p>
                <strong> Merchant Certified Omang Copy</strong>
              </p>
              <div className={"card card-default"}>
                {this.props.omang && this.props.omang[0] ? (
                  <div className={"card-body no-scroll no-padding dropzone "}>
                    <p
                      style={{
                        lineHeight: "50px",
                        margin: 0,
                        textAlign: "center",
                      }}
                    >
                      {this.props.omang[0].name}
                    </p>
                  </div>
                ) : (
                  <div className={"card-body no-scroll no-padding dropzone "}>
                    <Dropzone
                      config={componentConfig}
                      onDrop={this.props.onDrop1}
                      multiple={false}
                    >
                      {({ getRootProps, getInputProps, isDragActive }) => {
                        return (
                          <div
                            {...getRootProps()}
                            style={{ textAlign: "center" }}
                          >
                            <input {...getInputProps()} />
                            {isDragActive ? (
                              <p style={{ lineHeight: "50px", margin: 0 }}>
                                Drop files here...
                              </p>
                            ) : (
                              <p style={{ lineHeight: "50px", margin: 0 }}>
                                Click to select files to upload.
                              </p>
                            )}
                          </div>
                        );
                      }}
                    </Dropzone>
                  </div>
                )}
              </div>
            </div>
          </div>
          <br />
          <div className={"row clearfix"}>
            <div className={"col-lg-6"}>
              <p>
                <strong> Merchant Affidavit</strong>
              </p>
              <div className={"card card-default"}>
                {this.props.affidavit && this.props.affidavit[0] ? (
                  <div className={"card-body no-scroll no-padding dropzone "}>
                    <p
                      style={{
                        lineHeight: "50px",
                        margin: 0,
                        textAlign: "center",
                      }}
                    >
                      {this.props.affidavit[0].name}
                    </p>
                  </div>
                ) : (
                  <div className={"card-body no-scroll no-padding dropzone "}>
                    <Dropzone
                      config={componentConfig}
                      onDrop={this.props.onDrop2}
                      multiple={false}
                    >
                      {({ getRootProps, getInputProps, isDragActive }) => {
                        return (
                          <div
                            {...getRootProps()}
                            style={{ textAlign: "center" }}
                          >
                            <input {...getInputProps()} />
                            {isDragActive ? (
                              <p style={{ lineHeight: "50px", margin: 0 }}>
                                Drop files here...
                              </p>
                            ) : (
                              <p style={{ lineHeight: "50px", margin: 0 }}>
                                Click to select files to upload.
                              </p>
                            )}
                          </div>
                        );
                      }}
                    </Dropzone>
                  </div>
                )}
              </div>
            </div>
            <div className={"col-lg-6"}>
              <p>
                <strong> Hawkers License</strong>
              </p>
              <div className={"card card-default"}>
                {this.props.hawkersLicense && this.props.hawkersLicense[0] ? (
                  <div className={"card-body no-scroll no-padding dropzone "}>
                    <p
                      style={{
                        lineHeight: "50px",
                        margin: 0,
                        textAlign: "center",
                      }}
                    >
                      {this.props.hawkersLicense[0].name}
                    </p>
                  </div>
                ) : (
                  <div className={"card-body no-scroll no-padding dropzone "}>
                    <Dropzone
                      accept={HAWKERS_PDF_ACCEPT}
                      onDrop={this.props.onDrop3}
                      multiple={false}
                    >
                      {({ getRootProps, getInputProps, isDragActive }) => {
                        return (
                          <div
                            {...getRootProps()}
                            style={{ textAlign: "center" }}
                          >
                            <input {...getInputProps()} />
                            {isDragActive ? (
                              <p style={{ lineHeight: "50px", margin: 0 }}>
                                Drop files here...
                              </p>
                            ) : (
                              <p style={{ lineHeight: "50px", margin: 0 }}>
                                Click to select files to upload.
                              </p>
                            )}
                          </div>
                        );
                      }}
                    </Dropzone>
                  </div>
                )}
              </div>
            </div>
          </div>
          {this.props.attachementError ? (
            <p style={{ color: "red" }}>Attach all required files</p>
          ) : null}
        </div>
        <br />
        <p>
          <strong>Contact and Address</strong>
        </p>
        <div>
          <div className={"row clearfix"}>
            <div className={"col-sm-4"}>
              <Field
                // label="City"
                name="merchantCity"
                options={merchantCities}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                    primary: "neutral0",
                  },
                })}
                component={SelectInput}
                // type="text"
                className={"form-control input-sm overflow-y: auto"}
                placeholder={
                  this.props.merchantCity == undefined || null
                    ? "City"
                    : this.props.merchantCity
                }
                value={
                  this.props.merchantCity && this.props.merchantCity.value
                    ? this.props.merchantCity
                    : null
                }
                onChange={this.props.onmerchantCity}
                required="required"
                autoComplete="off"
              />
              {this.props.errorMessage && (
                <p style={{ color: "red" }}>{this.props.errorMessage}</p>
              )}
              <p
                style={{
                  color: "#6d5cae",
                  cursor: "pointer",
                  fontSize: "12px",
                  marginTop: "5px",
                  marginBottom: "0",
                }}
                onClick={this.toggleAddPlaceForm}
              >
                City not listed? Add new place
              </p>

              {this.state.showAddPlaceForm && (
                <div
                  className="card card-default"
                  style={{
                    padding: "15px",
                    marginTop: "10px",
                    backgroundColor: "#f9f9f9",
                    border: "1px solid #e8e8e8",
                  }}
                >
                  <div className="row" style={{ marginBottom: "10px" }}>
                    <div className="col-sm-12">
                      <label style={{ fontSize: "12px", marginBottom: "5px", display: "block" }}>
                        Select District
                      </label>
                      <select
                        className="form-control"
                        value={this.state.selectedDistrict}
                        onChange={(e) => this.setState({ selectedDistrict: e.target.value, addPlaceError: "" })}
                        style={{ height: "38px", width: "100%" }}
                      >
                        <option value="">Select District...</option>
                        {this.props.merchantCities &&
                          this.props.merchantCities.map((district) => (
                            <option key={district.id} value={district.id}>
                              {district.district}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row" style={{ marginBottom: "10px" }}>
                    <div className="col-sm-12">
                      <label style={{ fontSize: "12px", marginBottom: "5px", display: "block" }}>
                        New Place Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter place name"
                        value={this.state.newPlaceName}
                        onChange={(e) => this.setState({ newPlaceName: e.target.value, addPlaceError: "" })}
                        style={{ height: "38px", width: "100%" }}
                      />
                    </div>
                  </div>
                  {this.state.addPlaceError && (
                    <p style={{ color: "red", fontSize: "12px", marginBottom: "10px" }}>
                      {this.state.addPlaceError}
                    </p>
                  )}
                  <div className="row">
                    <div className="col-sm-12" style={{ display: "flex", gap: "10px" }}>
                      <button
                        type="button"
                        onClick={this.handleAddPlace}
                        disabled={this.state.isAddingPlace}
                        style={{
                          backgroundColor: "#6d5cae",
                          borderColor: "#6d5cae",
                          color: "#fff",
                          padding: "8px 20px",
                          border: "none",
                          cursor: this.state.isAddingPlace ? "not-allowed" : "pointer",
                          fontSize: "14px",
                        }}
                      >
                        {this.state.isAddingPlace ? "Adding..." : "Add Place"}
                      </button>
                      <button
                        type="button"
                        onClick={this.toggleAddPlaceForm}
                        style={{
                          backgroundColor: "#fff",
                          borderColor: "#e7e7e7",
                          color: "#5e5e5e",
                          padding: "8px 20px",
                          border: "1px solid #e7e7e7",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className={"col-sm-4"}>
              <Field
                // label="Suburb"
                name="merchantSuburb"
                component={TextInput}
                type="text"
                className={"form-control input-sm"}
                placeholder={
                  this.props.merchantSuburb == undefined || null
                    ? "Suburb / PO Box (Self Service)"
                    : this.props.merchantSuburb
                }
                onChange={this.props.onmerchantSuburb}
                required="required"
              />
            </div>
            <div className={"col-sm-4"}>
              <Field
                // label="Contact Name"
                name="merchant_contact_name"
                component={TextInput}
                type="text"
                className={"form-control input-sm"}
                placeholder={
                  this.props.merchant_contact_name == undefined || null
                    ? "Contact Person"
                    : this.props.merchant_contact_name
                }
                onChange={this.props.onmerchant_contact_name}
                required="required"
              />
            </div>
          </div>

          <div className={"row clearfix"}>
            <div className={"col-sm-4"}>
              <Field
                // label="Contact Email"
                name="merchant_contact_email"
                component={TextInput}
                type="text"
                className={"form-control input-sm"}
                placeholder={
                  this.props.merchant_contact_email == undefined || null
                    ? "Contact Email"
                    : this.props.merchant_contact_email
                }
                onChange={this.props.onmerchant_contact_email}
                required="required"
              />
            </div>
            <div className={"col-sm-4"}>
              <Field
                // label="Telephone Number"
                name="merchant_contact_telephone"
                component={TextInput}
                type="text"
                className={"form-control input-sm"}
                placeholder={
                  this.props.merchant_contact_telephone == undefined || null
                    ? "Telephone Number"
                    : this.props.merchant_contact_telephone
                }
                onChange={this.props.onmerchant_contact_telephone}
                required="required"
              />
            </div>
            <div className={"col-sm-4"}>
              <Field
                // label="Telephone Number"
                name="merchant_referral_code"
                component={TextInput}
                type="text"
                className={"form-control input-sm"}
                placeholder={
                  this.props.merchant_referral_code == undefined || null
                    ? "Referral number"
                    : this.props.merchant_referral_code
                }
                onChange={this.props.onmerchant_referral_code}
              />

              {this.props.validreferralcodeMsg ? (
                <p style={{ color: "red" }}>{this.props.merchant_name}</p>
              ) : null}

              {this.props.invalidreferralcodeError ? (
                <p style={{ color: "red" }}>Referral code is not valid</p>
              ) : null}
            </div>
          </div>
        </div>

        <br />
        <div
          className={
            "p-t-20 sm-padding-5 sm-m-b-20 sm-m-t-20 bg-white clearfix"
          }
        >
          <ul className={"pager wizard no-style"}>
            <li className="next">
              <button
                className={"btn btn-primary btn-cons pull-right"}
                type="submit"
                // onClick={handleNextClick}
              >
                <span>Next</span>
              </button>
            </li>
          </ul>
        </div>
      </form>
    );
  }
}

const query = (ownProps) => {
  return [
    {
      collection: "sellerId",
      orderBy: ["sellerId", "desc"],
    },
    {
      collection: "merchantTypes",
      orderBy: ["type", "asc"],
    },
    {
      collection: "botswana_districts",
      orderBy: ["places", "desc"],
    },
  ];
};

const mapState = (state) => ({
  sellerId: state.firestore.ordered.sellerId,
  merchantTypes: state.firestore.ordered.merchantTypes,
  merchantCities: state.firestore.ordered.botswana_districts,
});

export default compose(
  connect(mapState),
  reduxForm({
    form: "merchantForm",
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    asyncValidate,
    asyncBlurFields: ["merchantName"],
    validate,
  }),
  firestoreConnect(query)
)(MerchantDetails);
